<template>

<v-dialog v-model="dialog" width="500">
  
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="my-vicon">settings</v-icon>
        </template>

    <v-card>
          
          <!--<component :is="dynamicComponent"></component>-->
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
                
      </v-dialog>

</template>



<script>


export default {
    components: {
      
    },
    props: ["type"], 
    data(){
        return{
            selectedCharts: this.$store.state.userInfo.marketsSubscribe,
            marketMap: this.$store.state.marketMap,
            dialog: false,
        }
    },
    computed: {
      /*
    dynamicComponent() {
      if(this.type == 0){
        return "settingsCharts"
      }else{
        var selected = this.$store.state.userInfo.submenus.init[this.type]
        var init = this.$store.state.userInfo.submenus.data[this.type][selected]
        return `settings${this.$store.state.componentMap[init].component}`
      }
    },
    */
    
  },

}

</script>

<style scoped>

.my-vicon {
  color: #808f9c;
  font-size: 18px;
  margin-bottom: 5px;
}
.my-vicon:hover {
  color: #ffffff;
}

</style>
